/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_BoldInputs */



/**
* | output |
* | --- |
* | "Bold" |
*
* @param {Transcript_Export_BoldInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_bold = /** @type {((inputs?: Transcript_Export_BoldInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_BoldInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bold")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bold")
	if (locale === "it") return /** @type {LocalizedString} */ ("Bold")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Bold")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bold")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Bold")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Bold")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Bold")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Bold")
	return /** @type {LocalizedString} */ ("Bold")
});